<script lang="ts" setup>

</script>
<template>
  <PasswordConfirmationController v-slot="{ open, submit: onSubmit, cancel }" :action="$route('web.auth.password.confirm.store')" class="password-controller">
    <UiModal :open="open" medium @close="cancel">
      <SfHeading compact headingStyle type="span">
        {{ $t('SHOP.COMMON.HEADER.CONFIRM_PASSWORD') }}
      </SfHeading>
      <p>{{ $t('SHOP.COMMON.MESSAGE.CONFIRM_PASSWORD') }}</p>
      <FormController v-slot="{ processing, submit }" @submit="onSubmit">
        <div class="form-grid">
          <div class="full">
            <SfFormInput :label="$t('SHOP.COMMON.LABEL.PASSWORD')" autocomplete="new-password" name="password" required type="password" />
          </div>
        </div>
        <UiButtonGroup>
          <SfButton :loading="processing" primary @click="submit">
            {{ $t('SHOP.COMMON.ACTION.CONTINUE') }}
          </SfButton>
          <SfButton @click="cancel">
            {{ $t('SHOP.COMMON.ACTION.CANCEL') }}
          </SfButton>
        </UiButtonGroup>
      </FormController>
    </UiModal>
  </PasswordConfirmationController>
</template>
